module.exports = __webpack_public_path__ + "static/thumb-arreglo-complemento-0a1c9e2dccadbbbd69969d0d36f19780.jpg";